import { ChangeDetectionStrategy, Component, input } from '@angular/core';

export type ButtonVariant = 'primary' | 'secondary' | 'outline' | 'ghost' | 'danger';
export type ButtonSize = 'sm' | 'md' | 'lg';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'ui-button',
  styleUrl: './button.scss',
  templateUrl: './button.html',
})
export class ButtonComponent {
  /** Apparence visuelle du bouton. */
  readonly variant = input<ButtonVariant>('primary');

  /** Taille du bouton. */
  readonly size = input<ButtonSize>('md');

  /** Type HTML du bouton. */
  readonly type = input<'button' | 'submit' | 'reset'>('button');

  /** Désactive le bouton. */
  readonly disabled = input(false);

  /** Affiche un indicateur de chargement et bloque le clic. */
  readonly loading = input(false);

  /** Le bouton occupe toute la largeur disponible. */
  readonly fullWidth = input(false);

  protected get cssClass(): string {
    return [
      'ui-button',
      `ui-button--${this.variant()}`,
      `ui-button--${this.size()}`,
      this.fullWidth() ? 'ui-button--full' : '',
    ]
      .filter(Boolean)
      .join(' ');
  }
}
